function not<T>(a: readonly T[], b: readonly T[]) {
	return a.filter((value) => !b.includes(value));
}

function intersection<T>(a: readonly T[], b: readonly T[]) {
	return a.filter((value) => b.includes(value));
}

function union<T>(a: readonly T[], b: readonly T[]) {
	return [...a, ...not(b, a)];
}

export { not, intersection, union };
